import React, { useState } from 'react';
import { bool, func, string, node } from 'prop-types';
import 'apps/billing/styles/components/confirmation-page.scss';


const ConfirmationPage = (props) => {
  const [loading, setLoading] = useState(false);


  const handleConfirm = async () => {
    setLoading(true);
    let response = await props.onComplete();
    if (response) setLoading(false);
  };

  return (
    <div className="confirmation-step">
      <div className="confirmation-content">
        { props.children }
      </div>
      <div className="confirmation-actions">
        <button disabled={loading} onClick={handleConfirm}>{props.confirmText || 'YES'}</button>
        {props.noReject ? null : (
          <button onClick={()=>props.onReject()}>
            {props.rejectText || 'NO'}
          </button>
        )}
      </div>
    </div>
  );
};

export default ConfirmationPage;

ConfirmationPage.propTypes = {
  onComplete: func,
  onReject: func,
  children: node,
  confirmText: string,
  rejectText: string,
  noReject: bool,
};
